import React from 'react';
import ParliamentRedirect from '../ParliamentRedirect/ParliamentRedirect';

const CoinParliament: React.FC = () => {
    return <ParliamentRedirect parliamentName="Coin Parliament" />;
};

export default CoinParliament;
